import { useMemo } from 'react';
import _ from 'lodash';
import { useSelector } from 'react-redux';

const useForward = (create) => {
  const roomTypeList = useSelector((state) => state.initForwardList);

  const data = useMemo(() => {
    let list = [];
    if (Array.isArray(roomTypeList) && roomTypeList.length > 0) {
      list = _.map(roomTypeList, (item) => {
        return {
          text: item.name,
          value: item.value,
        };
      });
    }

    return list;
  }, [roomTypeList]);

  return create
    ? data
    : _.filter(data, (item) => {
        return item.value !== 2;
      });
};

export default useForward;
